import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { authSelector, departmentSelector, employeeSelector } from './../../../selectors'
import { departmentAction } from './../../../actions/'
import CustomTable from '../../../components/table'
import { employeeAction } from '../../../actions/employee'

const header = ['Start Date', 'Department ID', 'Department Name', 'Modified By']

class ListDepartment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      departments: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.listDepartment(access_token)
    this.props.getEmployeeList(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listDepartmentData) {
      this.setState({ departments: get(nextProps, 'listDepartmentData') })
    }
  }

  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.departments }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListDepartment.propTypes = {
  listDepartment: PropTypes.func.isRequired,
  listDepartmentData: PropTypes.array.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  getEmployeeList: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listDepartmentData: departmentSelector.getListDepartment,
  departmentDeactivate: departmentSelector.getDeactivateDepartmentData,
  redirectDepartment: departmentSelector.redirectDepartment,
  employeeList: employeeSelector.getListUser,
  authData: authSelector.getAuth,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listDepartment: departmentAction.getDepartment,
  deactivateDepartment: departmentAction.deactivateDepartment,
  resetDeactivateDepartment: departmentAction.resetDeactivateDepartment,
  resetListDepartment: departmentAction.resetListDepartment,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListDepartment)



// WEBPACK FOOTER //
// ./src/pages/department/list/index.js